



































































import { Component, Mixins } from "vue-property-decorator";

// Providers
import ContractCancellationProvider from "@/components/app/global/contracts/contractCancellationProvider";

// Mixins
import HasValidation from "@/mixins/HasValidation";

// Enums/Data
import { CancelOptions } from "@/data/enums/contracts";

@Component({
  components: {
    "contract-cancellation-options": () =>
      import(
        "@/components/app/global/contracts/contractCancellationOptions.vue"
      )
  }
})
export default class ClientContractCancellationModal extends Mixins(
  HasValidation,
  ContractCancellationProvider
) {
  public async validateBeforeSubmit() {
    this.isProcessing = true;
    try {
      if (!(await this.validate())) {
        throw this.$t("_sentence.form_is_not_valid");
      }
      await this.submit();
      this.$emit("contract-updated");
      this.$emit("close");
      this.$store.dispatch("toast/show", {
        message: this.$t(`_.cancellation_request_submitted`)
      });
    } catch (error) {
      this.$store.dispatch("api/handleValidationError", {
        error,
        vm: this
      });
    }
    this.isProcessing = false;
  }

  public submit() {
    return this.$_.get(
      this.$_.find(this.cancelOptions, ["id", this.cancelOption]),
      "onSubmit",
      () => Promise.resolve()
    )();
  }

  public get withImmediateEffect() {
    return this.cancelOption === CancelOptions.CANCEL_WITH_IMMEDIATE_EFFECT;
  }

  public get isCancelAtTheEnd() {
    return this.cancelOption === CancelOptions.CANCEL_AFTER_CURRENT_TERM;
  }
}
